import { render, staticRenderFns } from "./topicDetails.vue?vue&type=template&id=bb824ffc&scoped=true"
import script from "./topicDetails.vue?vue&type=script&lang=js"
export * from "./topicDetails.vue?vue&type=script&lang=js"
import style0 from "./topicDetails.vue?vue&type=style&index=0&id=bb824ffc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb824ffc",
  null
  
)

export default component.exports